import { combineReducers } from "redux";
import createAccountReducer from "./createAccount.reducer"
import sendLoginOTP from "./sendLoginOTP.reducer"
import verifyAccount from "./verifyAccount.reducer"
import verifyLoginOTP from "./verifyLoginOTP"
import getAcessToken from "../student/getAcessToken.reducer";

const authReducers = combineReducers({
    createAccountReducer, 
    sendLoginOTP,
    verifyAccount,
    verifyLoginOTP,
    getAcessToken
});

export default authReducers;
